import InputType from "@/services/Input/InputType.js";
import OutputType from "@/services/Input/OutputType.js";

// see details: "@/services/Input/DataCatalog.js"
// source: "@/components/Stock/StockCatalog.js"
export default {
  FullName: {
    Label: "Nama",
    Type: InputType.Text,
    ReadOnly: true,
    Highlight: true
  },
  WarehouseName: {
    Label: "Gudang",
    Type: InputType.Text,
    ReadOnly: true
  },
  SKU: {
    Label: "SKU",
    Type: InputType.Text,
    ReadOnly: true,
    Highlight: true
  },
  SellPrice: {
    Label: "Harga Jual",
    Type: InputType.Integer,
    ReadOnly: true,
    Output: OutputType.Integer.Currency
  },
  BuyPrice: {
    Label: "Harga Beli",
    Type: InputType.Integer,
    ReadOnly: true,
    Output: OutputType.Integer.Currency
  },
  Weight: {
    Label: "Berat (gram)",
    Type: InputType.Integer,
    ReadOnly: true
  },
  Quantity: {
    Label: "Stok",
    Type: InputType.Integer,
    ReadOnly: true
  },
  HppTotal: {
    Label: "Nilai Stok",
    Type: InputType.Decimal,
    ReadOnly: true,
    Output: OutputType.Decimal.Accounting2D
  },
  ImageSrc: {
    Label: "Gambar",
    Type: InputType.Text,
    ReadOnly: true
  },
  // support
  HppPerPcs: {
    Label: "Harga Pokok/Pcs",
    Type: InputType.Decimal,
    ReadOnly: true,
    Output: OutputType.Decimal.Accounting2D
  }
}